import React from 'react';

const ProductionValue = ({value}) => {
    let displayText = "";
    let textColor = "";

    switch (value?.toLowerCase()) {
        case "standard":
            displayText = "Standard";
            textColor = "text-green-500";
            break;
        case "pro":
            displayText = "Pro";
            textColor = "text-yellow-500";
            break;
        case "cinematic":
            displayText = "Cinematic";
            textColor = "text-red-500";
            break;
        default:
            displayText = value || "-";
            textColor = "text-gray-500";
    }

    return (
        <span className={`${textColor}`}>
            {displayText}
        </span>
    );
};

export default ProductionValue;